import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'

import Box from '@components/kit/box'
import Button from '@components/kit/button'
import Card from '@components/kit/card'
import { Column, Row } from '@components/kit/grid'
import Loading from '@components/kit/loading'
import Text from '@components/kit/text'

import { ChatContext } from '../chat.web'
import { useDocumentsStore } from '@store/Documents'
import { IUserDocument } from '@store/Documents/types'

function ExamDocuments() {
  const { userId } = useContext(ChatContext)
  const { getUserDocuments, getUserDocumentById } = useDocumentsStore.getState()
  const [documents, setDocuments] = useState<IUserDocument[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [downloadingId, setDownloadingId] = useState<number | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      const data = await getUserDocuments(userId)
      const examDocuments = data ?? [] //.filter(doc => doc.type === 'EXAM')
      setDocuments(examDocuments)
      setIsLoading(false)
    }
    fetchData()
  }, [userId])

  const handleDownload = async (documentId: number) => {
    setDownloadingId(documentId)
    const doc = await getUserDocumentById(userId, documentId)
    setDownloadingId(null)
    if (doc?.download_url) {
      window.open(doc.download_url, '_blank', 'noopener,noreferrer')
    }
  }

  const getFileName = (fileId: string) => {
    const parts = fileId.split('/')
    return parts[parts.length - 1] ?? fileId
  }

  return (
    <React.Fragment>
      <Row
        mt='24'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'
      >
        <Text ml='12' mb='08' font='display.16.bold'>
          Lab Documents
        </Text>
      </Row>
      <Card mt='08' px='00' py='00'>
        {isLoading ? (
          <Box pt='24'>
            <Loading mt='20' py='20' />
          </Box>
        ) : (
          <React.Fragment>
            <Row m='16'>
              <Column width='50%'>
                <Text font='text.12.bold'>File</Text>
              </Column>
              <Column width='25%'>
                <Text font='text.12.bold'>Date</Text>
              </Column>
              <Column width='25%' />
            </Row>

            {documents.length === 0 && (
              <Row mx='16' my='12'>
                <Text font='text.14.medium'>No documents available yet.</Text>
              </Row>
            )}

            {documents.map((doc, index) => (
              <React.Fragment key={doc.id}>
                <Row mx='16' my='12' alignItems='center'>
                  <Column width='50%' flexDirection='row' alignItems='center'>
                    <Text font='text.14.medium' numberOfLines={1}>
                      {getFileName(doc.file_id)}
                    </Text>
                  </Column>
                  <Column width='25%' flexDirection='row' alignItems='center'>
                    <Text font='text.14.medium'>
                      {moment(doc.created).format('MM/DD/YYYY')}
                    </Text>
                  </Column>
                  <Column
                    width='25%'
                    flexDirection='row'
                    alignItems='center'
                    justifyContent='flex-end'
                  >
                    <Button
                      size='fit'
                      variant='tertiary'
                      onPress={() => handleDownload(doc.id)}
                      disabled={downloadingId === doc.id}
                    >
                      {downloadingId === doc.id ? (
                        // px, py and fill copied from button size='fit' variant='tertiary'
                        <Box
                          py='08'
                          px='16'
                          justifyContent='center'
                          alignItems='center'
                        >
                          <Loading fill='walrusBlue500' size='small' />
                        </Box>
                      ) : (
                        'Download'
                      )}
                    </Button>
                  </Column>
                </Row>
                {index < documents.length - 1 && (
                  <Box mx='16' height='1px' backgroundColor='shade02' />
                )}
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
      </Card>
    </React.Fragment>
  )
}

export default ExamDocuments
